import classes from '@/components/Card/Card.module.scss';
import classNames from 'classnames';
import type { ReactNode } from 'react';

export type BoxVariants = 'Box' | 'Summary';

type BoxProps = {
  variant?: BoxVariants;
  title?: string;
  header?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  classNameHeader?: string;
  radius?: 'default' | 'large';
};

const Card: React.FC<BoxProps> = ({
  header = null,
  children,
  footer = null,
  title = null,
  className = '',
  classNameHeader = '',
  variant = 'Box',
  radius,
}) => {
  const variantClass = classes[`card${variant}`];
  return (
    <div className={classNames(classes.card, className, variantClass, { [classes.radiusLarge]: radius === 'large' })}>
      {header && <header className={classNames(classes.cardHeader, classNameHeader, 'cardHeader')}>{header}</header>}
      {!header && title && (
        <header className={classes.cardHeader}>
          {title && (
            <h4 data-testid="card-title" className={classes.cardTitle}>
              {title}
            </h4>
          )}
        </header>
      )}
      {children && <div className={classNames(classes.cardContent, 'cardContent')}>{children}</div>}
      {footer && <footer className={classes.cardFooter}>{footer}</footer>}
    </div>
  );
};

export default Card;
